var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('confirm-dialog',{ref:"confirm"}),_c('prompt-dialog',{ref:"prompt"}),_c('alert-dialog',{ref:"alert"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }